import { createAsyncThunk } from '@reduxjs/toolkit';
import { getMyPlan } from '@services/requests/billing';

export const ThunkGetMyPlan = createAsyncThunk('billing/getMyPlan', () =>
  getMyPlan(),
);

export default {};
